import { render, staticRenderFns } from "./SuperPass.vue?vue&type=template&id=3fe539e0&"
import script from "./SuperPass.vue?vue&type=script&lang=js&"
export * from "./SuperPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports